import { render, staticRenderFns } from "./TheBackgroundCanvas.vue?vue&type=template&id=331b4e0e&scoped=true"
import script from "./TheBackgroundCanvas.vue?vue&type=script&lang=js"
export * from "./TheBackgroundCanvas.vue?vue&type=script&lang=js"
import style0 from "./TheBackgroundCanvas.vue?vue&type=style&index=0&id=331b4e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331b4e0e",
  null
  
)

export default component.exports